import "react-datepicker/dist/react-datepicker.css";
import "./Datepicker.scss"
import ReactDatePicker from "react-datepicker";

const DatePicker = (
    {
        onChangeValue,
        value,
        dateFormat = "yyyy/MM/dd",
        placeholderText = "YYYY/MM/DD",
        ...props
    }
) => {

  const currentDateValue = isNaN(value.getTime()) ? undefined : value

  return (
    <ReactDatePicker
      className="date_input"
      popperClassName="date_calendar"
      monthClassName="date_title"
      selected={currentDateValue}
      placeholderText={placeholderText}
      dateFormat={dateFormat}
      onChange={onChangeValue}
      {...props}
    />
  );
};

export default DatePicker;
